/* ══════════════════════════════════════════════════════════════════════
   KELVIN — méga-menu à onglets                      Claude, 2026-09-15
   Changer de famille ne demande AUCUN aller-retour réseau : tous les
   groupes sont rendus par le serveur, on ne fait que démasquer.

   Le clavier suit le motif ARIA « tabs » : flèches pour changer
   d'onglet, Origine/Fin pour les extrêmes, un seul onglet dans l'ordre
   de tabulation à la fois (`tabindex` déplacé, pas dupliqué).
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__kelvinMegaMenu) return;
  window.__kelvinMegaMenu = true;

  function demarrer(mm) {
    var onglets = Array.prototype.slice.call(mm.querySelectorAll('[data-mm-onglet]'));
    var groupes = Array.prototype.slice.call(mm.querySelectorAll('[data-mm-groupe]'));
    if (!onglets.length) return;

    function montrer(id, donnerLeFocus) {
      onglets.forEach(function (o) {
        var actif = o.getAttribute('data-mm-onglet') === id;
        o.classList.toggle('is-actif', actif);
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
        o.tabIndex = actif ? 0 : -1;
        if (actif && donnerLeFocus) o.focus();
      });
      groupes.forEach(function (g) {
        g.hidden = g.getAttribute('data-mm-groupe') !== id;
      });
      /* Un rail qui vient d'apparaître n'avait aucune largeur mesurable
         tant qu'il était `hidden` : la flèche se réévalue ici. */
      groupes.forEach(majFleche);
    }

    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () {
        montrer(o.getAttribute('data-mm-onglet'), false);
      });
      o.addEventListener('keydown', function (e) {
        var suivant = null;
        if (e.key === 'ArrowRight') suivant = onglets[(i + 1) % onglets.length];
        else if (e.key === 'ArrowLeft') suivant = onglets[(i - 1 + onglets.length) % onglets.length];
        else if (e.key === 'Home') suivant = onglets[0];
        else if (e.key === 'End') suivant = onglets[onglets.length - 1];
        if (!suivant) return;
        e.preventDefault();
        montrer(suivant.getAttribute('data-mm-onglet'), true);
      });
    });

    /* --- la flèche ne s'affiche que sur un débordement RÉEL ---------- */
    function majFleche(groupe) {
      var rail = groupe.querySelector('[data-mm-rail]');
      var fleche = groupe.querySelector('[data-mm-suivant]');
      if (!rail || !fleche) return;
      /* 2 px de tolérance : les largeurs sous-pixel d'un `flex` calculé
         en vw font déborder de quelques centièmes sans rien à défiler. */
      var deborde = rail.scrollWidth - rail.clientWidth > 2;
      var aLaFin = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      fleche.hidden = !deborde || aLaFin;
    }

    groupes.forEach(function (g) {
      var rail = g.querySelector('[data-mm-rail]');
      var fleche = g.querySelector('[data-mm-suivant]');
      if (!rail || !fleche) return;
      fleche.addEventListener('click', function () {
        var carte = rail.querySelector('.mm__carte');
        var pas = carte ? carte.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: pas, behavior: 'smooth' });
      });
      rail.addEventListener('scroll', function () { majFleche(g); }, { passive: true });
    });

    function toutRemesurer() { groupes.forEach(majFleche); }
    window.addEventListener('resize', toutRemesurer);
    /* Les images arrivent après le HTML et changent la largeur du rail :
       sans ce second passage, la flèche manquerait au premier survol. */
    window.addEventListener('load', toutRemesurer);
    toutRemesurer();
  }

  function init() {
    var mm = document.querySelector('[data-mm]');
    if (mm) demarrer(mm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
